// extracted by mini-css-extract-plugin
module.exports = {"button":"ScreenHome_button__SC1Vk"};